export default __webpack_public_path__ + "static/media/averageFaceEmoji.092f03bb.svg";